import {
  IconAlertCircle,
  IconBook,
  IconCircle,
  IconCircleCheck,
  IconCircleMinus,
  IconCircleX,
  IconHelp,
  IconLoader,
  IconPlayerPause,
  IconPlayerPlay,
  IconPlayerStop,
  IconX,
} from '@tabler/icons-react';

export const getPrimaryStatusColor = (status) => {
  switch (status) {
    case 'UNSPECIFIED':
    case 'UNKNOWN':
    case 'LIMITED':
    case 'ENDED':
      return 'no-data-background-color';
    case 'ELIGIBLE':
      return 'success-background-color';
    case 'PAUSED':
    case 'LEARNING':
    case 'PENDING':
      return 'learning-background-color';
    case 'REMOVED':
    case 'NOT_ELIGIBLE':
    case 'MISCONFIGURED':
      return 'fail-background-color';
    default:
      return 'no-ad-data';
  }
};

export const getStatusIcon = (status) => {
  switch (status) {
    case 'UNSPECIFIED':
    case 'UNKNOWN':
      return IconHelp;
    case 'ENABLED':
      return IconPlayerPlay;
    case 'PAUSED':
      return IconPlayerPause;
    case 'REMOVED':
      return IconCircleX;
    default:
      return IconAlertCircle;
  }
};

export const getPrimaryStatusIcon = (status) => {
  switch (status) {
    case 'UNSPECIFIED':
    case 'UNKNOWN':
      return IconHelp;
    case 'ELIGIBLE':
      return IconCircleCheck;
    case 'PAUSED':
      return IconPlayerPause;
    case 'REMOVED':
      return IconCircleX;
    case 'ENDED':
      return IconPlayerStop;
    case 'PENDING':
      return IconLoader;
    case 'MISCONFIGURED':
      return IconAlertCircle;
    case 'LIMITED':
      return IconCircle;
    case 'LEARNING':
      return IconBook;
    case 'NOT_ELIGIBLE':
      return IconCircleMinus;
    default:
      return IconX;
  }
};

export const getAdStrengthIcon = (status) => {
  switch (status) {
    case 'UNSPECIFIED':
    case 'UNKNOWN':
      return IconHelp;
    case 'PENDING':
      return IconLoader;
    case 'NO_ADS':
      return IconCircleX;
    case 'POOR':
      return IconCircleMinus;
    case 'AVERAGE':
      return IconCircle;
    case 'GOOD':
      return IconCircle;
    case 'EXCELLENT':
      return IconCircleCheck;
    default:
      return IconX;
  }
};

export const getBadgeColor = (status) => {
  switch (status) {
    case 'NOT_ELIGIBLE':
    case 'REMOVED':
    case 'MISCONFIGURED':
      return 'danger';
    case 'UNSPECIFIED':
    case 'UNKNOWN':
    case 'NO_ADS':
    case 'LIMITED':
    case 'PAUSED':
    case 'POOR':
      return 'warning';
    case 'PENDING':
    case 'AVERAGE':
    case 'LEARNING':
    case 'ENDED':
      return 'info';
    case 'GOOD':
    case 'EXCELLENT':
    case 'ELIGIBLE':
    case 'ENABLED':
      return 'success';
    default:
      return 'secondary';
  }
};
